<div class="form-modal">
	<div class="form-modal__body">
		<a
			tabindex="0"
			(click)="onClose()"
			(keypress)="onClose()"
			class="close-modal"
			aria-label="Close additional resource edit form"
		>
			<img src="./assets/img/icons-svg/close-icon.svg" />
		</a>
		<div class="img-wrapper">
			<div class="clearfix"></div>
			<div class="title-wrapper">
				<h1>{{ title }}</h1>
			</div>
		</div>
		<div>
			<div class="form-wrapper-80">
				<form
					novalidate
					[formGroup]="additionalResourceForm"
					(ngSubmit)="doSave()"
				>
					<div class="app-c-form-group">
						<label class="app-c-form--label" for="title">Title</label>
						<input
							class="app-c-form-control"
							id="title"
							type="text"
							formControlName="title"
						/>
						<div class="error-message" *ngIf="f.title.touched && f.title.errors?.required">
							The additional resource needs a title
						</div>
					</div>
					<div class="app-c-form-group">
						<label class="app-c-form--label" for="description">Description</label>
						<input
							class="app-c-form-control"
							id="description"
							type="text"
							formControlName="description"
						/>
					</div>
					<div class="icon-input">
						<label for="logo">Logo</label>
						<input
							type="file"
							(change)="changeListener($event)"
							formControlName="logo"
						/>
					</div>
					<div class="app-c-form-group">
						<label class="app-c-form--label" for="link">Link</label>
						<input
							class="app-c-form-control"
							id="link"
							type="text"
							formControlName="link"
						/>
					</div>
					<div class="fixed-footer">
						<button
							tabindex="0"
							class="app-c-btn app-c-btn--primary app-c-btn--curve"
							[ngClass]="{
								active: additionalResourceForm.invalid
							}"
							[disabled]="additionalResourceForm.invalid"
						>
							Save
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
